/**
 * https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#kyukeisyatikeikaikuiki
 * @type {DebrisFlow}
 * 土砂災害警戒区域（土石流）
 */
module.exports = class DebrisFlow {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '土砂災害警戒区域の凡例',
        img      : 'https://cdn.jon-api.com/shikaku-map/usage-guide/sediment.png',
        sourceUrl: 'https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#kyukeisyatikeikaikuiki'
      }
    ];
  }
}
